import { defineRecipe } from '@chakra-ui/react';

export const heading = defineRecipe({
  className: 'chakra-heading',
  base: {
    fontFamily: 'heading',
    fontWeight: 'bold',
    _dark: {
      fontWeight: 'semibold',
    },
  },
  variants: {
    size: {
      xs: { textStyle: 'sm', lineHeight: 1.2, _dark: { fontWeight: 'semibold' } },
      sm: { textStyle: 'md', lineHeight: 1.2, _dark: { fontWeight: 'semibold' } },
      md: { textStyle: 'xl', lineHeight: 1.2, _dark: { fontWeight: 'semibold' } },
      lg: { textStyle: '3xl', lineHeight: 1.2, _dark: { fontWeight: 'normal' } },
      xl: { textStyle: '4xl', lineHeight: 1.2, _dark: { fontWeight: 'normal' } },
      '2xl': { textStyle: '5xl', lineHeight: 1, _dark: { lineHeight: 1.2, fontWeight: 'normal' } },
      '3xl': { textStyle: '6xl', lineHeight: 1, _dark: { lineHeight: 1.2, fontWeight: 'normal' } }, // Deprecated in modern theme
      '4xl': { textStyle: '7xl', lineHeight: 1, _dark: { lineHeight: 1.2, fontWeight: 'normal' } }, // Deprecated in modern theme
    },
  },
  defaultVariants: {
    size: 'xl',
  },
});
